import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { debounceTime, Subject } from 'rxjs';
import { DocumentFilters } from 'src/app/models/document';
import { MessageService } from '../../services/message.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Option } from '../select/select.component';
import { Case, CaseType } from 'src/app/models/case';
import { AfterViewInit } from '@angular/core';



@Component({
  selector: 'app-document-filters-drawer',
  templateUrl: './document-filters-drawer.component.html',
  styleUrls: ['./document-filters-drawer.component.scss']
})
export class DocumentFiltersDrawerComponent implements AfterViewInit {
  CaseType = CaseType;

  @ViewChild('drawer') drawer!: MatDrawer;

  @Input() entityKey: string = 'ENTITIES.DOCUMENT'

  @Input() filters!: DocumentFilters;
  @Output() filtersChange = new EventEmitter<DocumentFilters>();

  public readonly filtersSubject = new Subject<DocumentFilters>();

  get filtersCount(): number {
    return (this.filters.approval.length > 0 ? 1 : 0)
      + (this.filters.classNumber.length > 0 ? 1 : 0)
      + (this.filters.territories.length > 0 ? 1 : 0)
      + (this.filters.documentClass.length > 0 ? 1 : 0)
      + (this.filters.trademark.length > 0 ? 1 : 0)
      + (this.filters.trademarkFamily.length > 0 ? 1 : 0)
      + ((this.filters.period.start !== undefined || this.filters.period.end !== undefined) ? 1 : 0)
      + (this.filters.productsServices.length > 0 ? 1 : 0)
      + (this.filters.tags.length > 0 ? 1 : 0)
  }

  constructor(
    private readonly _message: MessageService
  ) {


    this.filtersSubject
      .pipe(
        debounceTime(300),
        takeUntilDestroyed()
      ).subscribe((filters) => {
        this.filtersChange.emit(filters)
      });
  }

  ngAfterViewInit(): void {

  }


  public toggleDrawer(): void {
    void this.drawer.toggle();
  }

  public closeDrawer(): void {
    void this.drawer.close();
  }

  private emitFiltersChange(filters: DocumentFilters): void {
    this.filtersSubject.next(filters);
  }


  public onQueryChange(query: any): void {
    if (typeof query === 'string') {
      this.emitFiltersChange(this.filters);
    }
  }

  public onDocumentApprovalChange(event: any): void {
    if (event?.value) {
      this.filters.approval = event.value.map((appr: any) => appr.value);
      this.emitFiltersChange(this.filters);
    }
  }

  public onDocumentClassChange(event: any): void {
    if (event?.value) {
      this.filters.documentClass = event.value.map((v: any) => v.value);
      this.emitFiltersChange(this.filters);
    }
  }

  public onTrademarkFamilyChange(event: any): void {
    if (event?.value) {
      this.filters.trademarkFamily = event.value;
      this.emitFiltersChange(this.filters);
    }
  }

  public onTrademarkChange(event: any): void {
    if (event?.value) {
      this.filters.trademark = event.value;
      this.emitFiltersChange(this.filters);
    }
  }

  public onNiceClassificationChange(event: any): void {
    if (event?.value) {
      this.filters.classNumber = event.value.map((niceClass: any) => niceClass.classNumber);
      this.emitFiltersChange(this.filters);
    }
  }

  public onProductServiceChange(event: any): void {
    if (event?.value) {
      this.filters.productsServices = event.value;
      this.emitFiltersChange(this.filters);
    }
  }

  public onTerritoryChange(event: any): void {
    if (event?.value) {
      this.filters.territories = event.value.map((territory: any) =>
        territory.alternateCodes ? [territory.id, ...territory.alternateCodes] : [territory.id]
      ).flat();
      this.emitFiltersChange(this.filters);
    }
  }

  public onPeriodChange(event: any): void {
    if (event?.hasOwnProperty('start') && event?.hasOwnProperty('end')) {
      this.filters.period = event;
      this.emitFiltersChange(this.filters);
    }
  }

  public onTagChange(event: any): void {
    if (event?.value) {
      this.filters.tags = event.value;
      this.emitFiltersChange(this.filters);
    }
  }
}
